// extracted by mini-css-extract-plugin
export var button = "PreviewModal-module--button--61f79";
export var container = "PreviewModal-module--container--ff211";
export var fadeInAnimation = "PreviewModal-module--fadeInAnimation--e13eb";
export var gdpr = "PreviewModal-module--gdpr--22e60";
export var open = "PreviewModal-module--open--b6041";
export var panel = "PreviewModal-module--panel--12136";
export var small = "PreviewModal-module--small--3acd0";
export var tagsWrapper = "PreviewModal-module--tagsWrapper--9fb02";
export var title = "PreviewModal-module--title--26494";
export var wrapper = "PreviewModal-module--wrapper--35d1d";